module.exports = __webpack_public_path__ + "static/media/masterP.cbbc5e6e.png";